import type { RouteRecordRaw } from "vue-router";

function returnHomePage(): Promise<any> {
  return import("@/pages/landing-sparkmoi/IndexPage.vue");
}

export const landingRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "index",
    component: () => returnHomePage(),
    meta: { requiresAuth: false },
  },
  {
    path: "/home",
    name: "home",
    component: () => returnHomePage(),
    meta: { requiresAuth: false },
  },
];
